import React from 'react';
import { string, bool, func } from 'prop-types';
import classnames from 'classnames';
import { productShape } from 'shapes';
import { Icons } from 'components';
import './WishlistButton.scss';

export default function WishlistButton({
    className,
    active,
    onClick,
    product,
    isB2B,
}) {
    const rootClassnames = classnames(className, 'wishlist-button');
    const iconClassnames = classnames('wishlist-button__icon', {
        'wishlist-button__icon--b2b': isB2B,
        'wishlist-button__icon--active': active,
    });

    const handleClick = event => {
        event.preventDefault();
        if (onClick) {
            onClick(event);
        }
    };

    const B2BIcons = active ? (
        <Icons.ListFilled className={iconClassnames} />
    ) : (
        <Icons.List className={iconClassnames} />
    );
    const B2CIcons = active ? (
        <Icons.HeartFilled className={iconClassnames} />
    ) : (
        <Icons.Heart className={iconClassnames} />
    );

    return (
        <button
            className={rootClassnames}
            onClick={handleClick}
            data-name={product.title}
            data-rating={product.rating}
            data-ratting-count={product.ratingCount}
            data-url={product.url}
            data-image={product.image_fullpath}
            data-quantity={product.minQuantity || 1}
            data-product-id={product.objectID}
            data-price={product.price}
            data-article-id={product.article_id}
            data-product-brand={product.brand_name}
            data-category-id={product['categories.last_id']}
            data-has-x-payment={product.has_3x_payment ? 'true' : 'false'}
            data-event="add_to_wishlist"
            data-event-trigger="listing"
            data-qa="wishlistIconCta"
        >
            {isB2B ? B2BIcons : B2CIcons}
        </button>
    );
}

WishlistButton.propTypes = {
    className: string,
    active: bool,
    onClick: func,
    product: productShape.isRequired,
    isB2B: bool.isRequired,
};

WishlistButton.defaultProps = {
    className: null,
    active: false,
    onClick: null,
};
